"use client";

import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "react-i18next";

const WhatGetgeekDoes = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FFFFFF",
        direction: isRTL ? "rtl" : "ltr",
        mt: '2%'
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Box
          sx={{
            textAlign: { xs: isRTL ? "right" : "left", sm: "center" },
            mb: { xs: 1.5, sm: 2, md: 2 },
            px: { xs: 1, sm: 2, md: 0 },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: {
                xs: "1.6rem",
                sm: "2rem",
                md: "2.4rem",
                lg: "2.6rem",
              },
              fontWeight: "600",
              lineHeight: { xs: 1.3, md: 1.2 },
              fontFamily: "var(--font-plusjakarta)",
              color: "#020617",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("whatGetgeekDoes.title1")}{" "}
            <span style={{ color: "#9048FB" }}>
              {t("whatGetgeekDoes.titleHighlight")}
            </span>{" "}
            {t("whatGetgeekDoes.title2")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#81838c",
              fontSize: {
                xs: "0.875rem",
                sm: "1rem",
                md: "1.05rem",
                lg: "18px",
              },
              fontWeight: "400",
              fontFamily: isRTL ? "var(--font-outfit)" : "var(--font-outfit)",
              lineHeight: { xs: 1.6, md: 1.7 },
              maxWidth: { xs: "100%", sm: "780px" },
              mx: { xs: 0, sm: "auto" },
            }}
          >
            {t("whatGetgeekDoes.desc")}
          </Typography>
        </Box>
      </Container>

      {/* Bottom Image - true full width, breaks out of any parent padding */}
      <Box
        sx={{
          position: "relative",
          width: "96vw",
          marginLeft: "calc(-50vw + 50%)",
          marginRight: "calc(-50vw + 50%)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            transform: { xs: "scaleX(1.04)", sm: "scaleX(1.06)", md: "scaleX(1.08)" },
            transformOrigin: "center top",
          }}
        >
          <Image
            src="https://getgeek-website-assets.b-cdn.net/WhatGetgeekDoes.webp"
            alt={t("whatGetgeekDoes.imageAlt")}
            width={928}
            height={310}
            sizes="100vw"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
            quality={90}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default WhatGetgeekDoes;